import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NewHeader, PageHeader } from './AuxiliaryFunctions';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import { useDispatch, } from "react-redux";
import { changepsw } from "./actions/auth.js";
import { logout } from "./actions/auth.js";
import { useSelector } from 'react-redux';
import TopAndSideBar from './TopAndSideBar.js';
import UserDataService from "./services/user.serviceaux.js";

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  margin-top: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
`;


const Message = styled.p`
  color: green;
  margin-top: 1rem;
  text-align: center;
`;

const Profile = (props) => {
  const [profile, setProfile] = useState({});
  const { user: currentUser } = useSelector((state) => state.auth);	  

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);

  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const dispatch = useDispatch();

  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [message, setMessage] = useState('');

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    UserDataService.update(currentUser.id, profile)
    .then(resp => {
      console.log(resp);
      setShowsuccess(true);
      setSuccmessage(resp.data.message);
      setShowerror(false);
      return;
    })
    .catch(err => {
      if (err.response.status === 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
       console.log(err.response);
      }
      setShowsuccess(false);
      setErrmessage(err.response.data.message);
      setShowerror(true);
      return;
    });
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = passwords;
    if (newPassword !== confirmPassword) {
      setShowsuccess(false);
      setErrmessage('Passwords do not match!');
      setShowerror(true);
      return;
    }
    if (newPassword.length === 0) {
      setShowsuccess(false);
      setErrmessage('New password cannot be null!');
      setShowerror(true);
      return;
    }    
    changePassword();
  };


  let changePassword = () => {
    console.log(profile);
    var data = {
      userid: profile.id,
      currentpassword: passwords.currentPassword,
      newpassword: passwords.newPassword,
    }    
    dispatch(changepsw(data.userid, data.currentpassword, data.newpassword)) 
    .then((resp) => {
      console.log(resp);
      setShowerror(false);
      setSuccmessage('Your password has been updated!');
      setShowsuccess(true);
    })
    .catch((e) => {
      setShowsuccess(false);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);
    });     
  };

  useEffect(()=> {
    UserDataService.get(currentUser.id) 
    .then(resp => {
      //console.log(resp.data);
      let respdata = resp.data[0];
      respdata.roles = respdata.roles.map(rol => rol.id);
      console.log(respdata);
      setProfile(respdata);
    })
    .catch(err => {
      console.log(err);
    });
  }, [])  

  return (
    <>
    <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
      <TopAndSideBar />
      <NewHeader headerTitle="My Profile" />
    </div>
    <Container style={{width:"80%"}}>
      <Row className='m-4'>
      <div
        className="card card-container "
        style={{maxWidth:'700px',padding:'40px 40px',}}>
    
        <Form onSubmit={handleProfileSubmit}>
          <Label>First Name</Label>
          <Input
            type="text"
            name="userfirstname"
            defaultValue={profile.userfirstname}
            onChange={handleProfileChange}
          />

          <Label>Last Name</Label>
          <Input
            type="text"
            name="userlastname"
            defaultValue={profile.userlastname}
            onChange={handleProfileChange}
          />                    

          <Label>Email</Label>
          <Input
            disabled
            type="email"
            name="email"
            defaultValue={profile.email}
            onChange={handleProfileChange}
          />

          <Label>Employee Number</Label>
          <Input
            type="text"
            name="employeenumber"
            defaultValue={profile.employeenumber}
            onChange={handleProfileChange}
          />          

          <Button type="submit">Update Profile</Button>
        </Form>
      </div>


      <div
        className="card card-container "
        style={{maxWidth:'700px',padding:'40px 40px',}}>
        <Form onSubmit={handlePasswordSubmit}>
          <Label>Current Password</Label>
          <Input
            type="password"
            name="currentPassword"
            value={passwords.currentPassword}
            onChange={handlePasswordChange}
          />

          <Label>New Password</Label>
          <Input
            type="password"
            name="newPassword"
            value={passwords.newPassword}
            onChange={handlePasswordChange}
          />

          <Label>Confirm Password</Label>
          <Input
            type="password"
            name="confirmPassword"
            value={passwords.confirmPassword}
            onChange={handlePasswordChange}
          />

          <Button type="submit">Change Password</Button>
        </Form>     
      </div>


      </Row>

      <Row className='mt-2'>
      {showerror && (
        <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
          <Alert.Heading>Error</Alert.Heading>
          <p>{errmessage}</p>
        </Alert>      
      )}
      {showsuccess && (
        <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
          <Alert.Heading>Done</Alert.Heading>
          <p>{succmessage}</p>
        </Alert>      
      )} 
      </Row>         

    </Container>
    </>
  );
};

export default Profile;